import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SupportingDocumentGridRuleService {
  evaluate<T = any>(expression: string, context: Record<string, any>, fallback: T): T {
    if (!expression || !String(expression).trim()) {
      return fallback;
    }

    try {
      const source = String(expression).trim();
      const body = this.isScriptBody(source)
        ? source
        : `return (${source});`;
      const fn = new Function(
        'context',
        `
          const data = context.data;
          const row = context.row;
          const user = context.user;
          const documents = context.documents;
          const rules = context.rules;
          const application = context.application;
          const config = context.config;
          const features = context.features;
          const readOnly = context.readOnly;
          const currentSectionName = context.currentSectionName;
          const missingRequiredDocuments = context.missingRequiredDocuments;
          const hasMissingRequiredDocuments = context.hasMissingRequiredDocuments;
          const canProceed = context.canProceed;
          const normalizeStatus = context.normalizeStatus;
          const addDays = context.addDays;
          const today = context.today;
          ${body}
        `
      );
      const result = fn(context);
      return (result === undefined ? fallback : result) as T;
    } catch (error) {
      console.error('Supporting document grid rule evaluation failed:', expression, error);
      return fallback;
    }
  }

  private isScriptBody(expression: string): boolean {
    const value = String(expression || '').trim();
    return value.includes(';')
      || value.includes('return ')
      || value.includes('if ')
      || value.includes('while ')
      || value.includes('for ')
      || value.includes('const ')
      || value.includes('let ')
      || value.includes('var ');
  }
}
